require("!!/app/SPA/node_modules/script-loader/addScript.js")(require("!!/app/SPA/node_modules/raw-loader/index.js!/app/SPA/node_modules/bootstrap-material-design/dist/js/material.min.js"))


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/script-loader!/app/SPA/~/bootstrap-material-design/dist/js/material.min.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap-material-design/dist/js/material.min.js
// module chunks = 3